// No known facet (for now at least?)
export enum FacetsEnum {}

export type Facets = `${FacetsEnum}`;

export const defaultFacets = [];
